import {
  handleWithErrorMessage,
  handleWithGlobalMessage,
  errorHandler
} from "@/services/utils";
import interviewsApi from "@/services/modules/bookings/interviews";
import {
  SET_IS_FETCHING_INTERVIEW_TEMPLATES,
  SET_IS_FETCHING_INTERVIEW_FORMATS,
  SET_IS_FETCHING_INTERVIEW_FORMAT,
  SET_INTERVIEW_FORMATS,
  SET_CURRENT_INTERVIEW_FORMAT,
  SET_INTERVIEW_TEMPLATES,
  SET_INTERVIEWERS,
  SET_IS_FETCHING_INTERVIEWERS,
  SET_INTERVIEW_SLOTS,
  SET_IS_FETCHING_INTERVIEW_SLOTS,
  SET_IS_FETCHING_INTERVIEW_SLOT,
  SET_CURRENT_INTERVIEW_SLOT,
  SET_SELF_SCHEDULE_SLOTS,
  SET_IS_FETCHING_SELF_SCHEDULE_SLOTS,
  SET_IS_FETCHING_FEEDBACK_CRITERIA,
  SET_FEEDBACK_CRITERIA,
  SET_IS_FETCHING_INTERVIEW_INVITES,
  SET_INTERVIEW_INVITES
} from "@/store/modules/bookings/interviews/mutations";

export const FETCH_INTERVIEW_TEMPLATES = "FETCH_INTERVIEW_TEMPLATES";
export const FETCH_INTERVIEW_FORMAT_AVAILABLE_SLOTS =
  "FETCH_INTERVIEW_FORMAT_AVAILABLE_SLOTS";
export const CREATE_INTERVIEW_SLOT = "CREATE_INTERVIEW_SLOT";
export const FETCH_BOOKING_INTERVIEW_FORMATS =
  "FETCH_BOOKING_INTERVIEW_FORMATS";
export const FETCH_INTERVIEW_FORMAT = "FETCH_INTERVIEW_FORMAT";
export const FETCH_INTERVIEWERS = "FETCH_INTERVIEWERS";
export const EDIT_SELF_SCHEDULE_SLOTS = "EDIT_SELF_SCHEDULE_SLOTS";
export const EDIT_INTERVIEW_FORMAT = "EDIT_INTERVIEW_FORMAT";
export const CREATE_SELF_SCHEDULE_SLOTS = "CREATE_SELF_SCHEDULE_SLOTS";
export const FETCH_INTERVIEW_SLOTS = "FETCH_INTERVIEW_SLOTS";
export const FETCH_INTERVIEW_INVITES = "FETCH_INTERVIEW_INVITES";
export const FETCH_INTERVIEW_SLOT = "FETCH_INTERVIEW_SLOT";
export const EDIT_INTERVIEW_PARTICIPANT = "EDIT_INTERVIEW_PARTICIPANT";
export const FETCH_SELF_SCHEDULE_SLOTS = "FETCH_SELF_SCHEDULE_SLOTS";
export const ADD_SELF_SCHEDULE_SLOT_PARTICIPANT =
  "ADD_SELF_SCHEDULE_SLOT_PARTICIPANT";
export const RESCHEDULE_SLOT = "RESCHEDULE_SLOT";
export const EDIT_INTERVIEW_SLOT = "EDIT_INTERVIEW_SLOT";
export const ADD_INTERVIEW_FEEDBACK = "ADD_INTERVIEW_FEEDBACK";
export const EDIT_INTERVIEW_FEEDBACK = "EDIT_INTERVIEW_FEEDBACK";
export const FETCH_INTERVIEW_FORMAT_FEEDBACK_CRITERIA =
  "FETCH_INTERVIEW_FORMAT_FEEDBACK_CRITERIA";
export const ADD_SELF_SCHEDULE_INVITE = "ADD_SELF_SCHEDULE_INVITE";
export const FETCH_INTERVIEW_FORMAT_FILES = "FETCH_INTERVIEW_FORMAT_FILES";
export const ADD_INTERVIEW_FORMAT = "ADD_INTERVIEW_FORMAT";

const actions = {
  async [FETCH_INTERVIEW_TEMPLATES]({ commit, dispatch }) {
    return handleWithErrorMessage({
      dispatch,
      request: interviewsApi(commit).getInterviewTemplates,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_INTERVIEW_TEMPLATES, isLoading),
      setDataFunction: ({ data }) => commit(SET_INTERVIEW_TEMPLATES, data)
    });
  },
  async [FETCH_BOOKING_INTERVIEW_FORMATS](
    { commit, dispatch },
    { bookingId, withInclude }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).getBookingInterviewFormats(
          bookingId,
          withInclude
        ),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_INTERVIEW_FORMATS, isLoading),
      setDataFunction: ({ data }) => commit(SET_INTERVIEW_FORMATS, data)
    });
  },
  async [FETCH_INTERVIEW_FORMAT](
    { commit, dispatch },
    { interviewFormatId, params }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).getInterviewFormat(interviewFormatId, params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_INTERVIEW_FORMAT, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_INTERVIEW_FORMAT, data)
    });
  },
  async [FETCH_INTERVIEW_FORMAT_AVAILABLE_SLOTS](
    { commit, dispatch },
    { interviewFormatId, params }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).getInterviewFormatAvailableSlots(
          interviewFormatId,
          params
        )
    });
  },
  async [FETCH_INTERVIEW_FORMAT_FEEDBACK_CRITERIA](
    { commit, dispatch },
    interviewFormatId
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).getInterviewFormatFeedbackCriteria(
          interviewFormatId
        ),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_FEEDBACK_CRITERIA, isLoading),
      setDataFunction: ({ data }) => commit(SET_FEEDBACK_CRITERIA, data)
    });
  },
  async [FETCH_INTERVIEW_FORMAT_FILES](
    { commit, dispatch },
    { interviewFormatId, collection }
  ) {
    try {
      const { data } = await interviewsApi(commit).getInterviewFormatFiles({
        interviewFormatId,
        collection
      });
      return data;
    } catch (error) {
      errorHandler(dispatch, error);
    }
  },
  async [FETCH_SELF_SCHEDULE_SLOTS]({ commit, dispatch }, interviewFormatId) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).getSelfScheduleSlots(interviewFormatId),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_SELF_SCHEDULE_SLOTS, isLoading),
      setDataFunction: ({ data }) => commit(SET_SELF_SCHEDULE_SLOTS, data)
    });
  },
  async [FETCH_INTERVIEW_SLOTS]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => interviewsApi(commit).getInterviewSlots(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_INTERVIEW_SLOTS, isLoading),
      setDataFunction: ({ data }) => commit(SET_INTERVIEW_SLOTS, data)
    });
  },
  async [FETCH_INTERVIEW_INVITES]({ commit, dispatch }, bookingId) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).getInterviewInvitations({
          filter: {
            booking_id: bookingId
          }
        }),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_INTERVIEW_INVITES, isLoading),
      setDataFunction: ({ data }) => commit(SET_INTERVIEW_INVITES, data)
    });
  },
  async [FETCH_INTERVIEW_SLOT]({ commit, dispatch }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => interviewsApi(commit).getInterviewSlot(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_INTERVIEW_SLOT, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_INTERVIEW_SLOT, data)
    });
  },
  async [CREATE_INTERVIEW_SLOT](
    { commit, dispatch },
    { interviewSlot, interviewFormatId }
  ) {
    return handleWithGlobalMessage(
      () =>
        interviewsApi(commit).createInterviewSlot(
          interviewSlot,
          interviewFormatId
        ),
      dispatch
    );
  },
  async [ADD_SELF_SCHEDULE_SLOT_PARTICIPANT](
    { commit, dispatch },
    { interviewFormatId, params }
  ) {
    return handleWithGlobalMessage(
      () =>
        interviewsApi(commit).createSelfScheduleSlotParticipant(
          interviewFormatId,
          params
        ),
      dispatch
    );
  },
  async [ADD_INTERVIEW_FEEDBACK]({ commit, dispatch }, interviewFeedback) {
    return handleWithErrorMessage({
      request: () =>
        interviewsApi(commit).createInterviewFeedback(interviewFeedback),
      dispatch
    });
  },
  async [EDIT_INTERVIEW_FEEDBACK]({ commit, dispatch }, { data, id }) {
    return handleWithErrorMessage({
      request: () => interviewsApi(commit).editInterviewFeedback(data, id),
      dispatch
    });
  },
  async [RESCHEDULE_SLOT]({ commit, dispatch }, { data, interviewFormatId }) {
    const {
      data: { id }
    } = await handleWithGlobalMessage(
      () => interviewsApi(commit).rescheduleSlot(data, interviewFormatId),
      dispatch
    );
    dispatch(FETCH_INTERVIEW_SLOT, id);
    return id;
  },
  async [EDIT_INTERVIEW_SLOT]({ commit, dispatch }, { id, data }) {
    await handleWithGlobalMessage(
      () => interviewsApi(commit).editInterviewSlot(id, data),
      dispatch
    );
    dispatch(FETCH_INTERVIEW_SLOT, id);
  },
  async [FETCH_INTERVIEWERS]({ commit, dispatch }, interviewFormatId) {
    return handleWithErrorMessage({
      request: () => interviewsApi(commit).getInterviewers(interviewFormatId),
      dispatch,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_INTERVIEWERS, isLoading),
      setDataFunction: ({ data }) => commit(SET_INTERVIEWERS, data)
    });
  },
  async [EDIT_INTERVIEW_FORMAT](
    { commit, dispatch },
    { interviewDetails, id }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).editInterviewFormat(interviewDetails, id)
    });
  },
  async [EDIT_SELF_SCHEDULE_SLOTS](
    { commit, dispatch },
    { interviewFormatId, data }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        interviewsApi(commit).editSelfScheduleSlots(data, interviewFormatId)
    });
  },
  async [CREATE_SELF_SCHEDULE_SLOTS](
    { commit, dispatch },
    { data, interviewFormatId, bookingId }
  ) {
    await handleWithErrorMessage({
      request: () =>
        interviewsApi(commit).createSelfScheduleSlots(data, interviewFormatId),
      dispatch
    });
    dispatch(FETCH_INTERVIEW_INVITES, bookingId);
  },
  async [ADD_SELF_SCHEDULE_INVITE](
    { commit, dispatch },
    { data, interviewFormatId, bookingId }
  ) {
    await handleWithErrorMessage({
      request: () =>
        interviewsApi(commit).createSelfScheduleInvite(interviewFormatId, data),
      dispatch
    });
    dispatch(FETCH_INTERVIEW_INVITES, bookingId);
  },
  async [EDIT_INTERVIEW_PARTICIPANT](
    { dispatch, commit },
    { interviewId, participantId, data, refreshInterviewSlot }
  ) {
    await handleWithGlobalMessage(
      () =>
        interviewsApi(commit).editInterviewParticipant({
          interviewId,
          participantId,
          data
        }),
      dispatch
    );
    if (refreshInterviewSlot) {
      dispatch(FETCH_INTERVIEW_SLOT, interviewId);
    }
  },
  async [ADD_INTERVIEW_FORMAT]({ commit, dispatch }, data) {
    return handleWithErrorMessage({
      dispatch,
      request: () => interviewsApi(commit).addInterviewFormat(data)
    });
  }
};

export default actions;
